import { render, staticRenderFns } from "./CustomerBasicDetails.vue?vue&type=template&id=63ea2035&scoped=true"
import script from "./CustomerBasicDetails.vue?vue&type=script&lang=js"
export * from "./CustomerBasicDetails.vue?vue&type=script&lang=js"
import style0 from "./CustomerBasicDetails.vue?vue&type=style&index=0&id=63ea2035&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ea2035",
  null
  
)

export default component.exports